import React, {useState, useEffect } from "react";
import "../styles/settings.scss";
import Header from "../components/header";
import Footer from "../components/footer"; 
import "../styles/components/categorie.scss";
import { useHistory } from "react-router-dom";
import Movie from "../components/Movie";


import axios from "axios";




const Demo = () => {

  const history = useHistory();

	const [data, setData] = useState([]);
    const [query, setQuery] = useState("");

    useEffect(() => {
        axios.get(`https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=en-US&query=${query}`)
             .then((res) => setData(res.data.results));
    }, [query]);

    const onSearch = (e) => {
        setQuery(e.target.value);
    }





	



	return (
		<div>
			<Header />

		


<header className="header_categorie_1">
      <h1> ACTION </h1>
      <div className="categorie-container">
        <div className="row">
          {data.map((m) => (
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 mb-4 col-xl-2 col-xxl-2" key={m.id}>
              <Movie >
              <a onClick={() =>
														history.push(`/movieDetails/${m.id}`)
													}>
                <div className="container">
                  <div className="movie-card">
                    <div className="poster">
                      <img src={m.posterUrl} alt={m.title} />
                    </div>
                    <div className="details">
                      <div className="tags">
                        <span>{m.releaseDate}</span>
                      </div>
                      <div className="description">
                        <p>{m.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              </Movie>
            </div>
          ))}
        </div>
      </div>
    </header>



			<Footer />
		</div>
	);
};

export default Demo;
